export { GdprConsentStatus } from "./GdprConsentStatus"

/*
  Consent status tracking:
  - fetch initial value, as user may have consented on a previous visit.
  - monitor for consent status changing on this visit, as this occurs when
    the user clicks the buttons presented on the consent pop-up dialog.
 */

import {
  consentStatus,
  THE_CONVERSATION_VENDOR_ID,
} from "@theconversation/shared-components/Didomi"

import { isEnabled } from "common/components/Didomi"
import { RegionConfiguration } from "modules/i18n/utils/loadRegionConfiguration"

export function setInitialDidomiUserStatus(
  regionConfig: RegionConfiguration,
  callback: (consent: boolean) => void,
) {
  // If Didomi isn't even enabled, default to true
  if (!isEnabled(regionConfig)) {
    callback(true)
    return
  }

  consentStatus({
    vendorId: THE_CONVERSATION_VENDOR_ID,
    purpose: "measure_content_performance",
  }).then((consent) => callback(consent))
}
